import { useToast } from '@lifebit-ai/lds'
import { UseMutationOptions, useMutation, useQueryClient } from '@tanstack/react-query'

import { invalidateRequestActivityQueries } from 'services/request-activity/invalidateRequestActivityQueries'
import { bulkAssignExportRequests } from 'services/results'
import type { BulkAssignExportRequestsParams, BulkAssignExportRequestsResponse } from 'services/results/types'
import type { ApiErrorResponse } from 'services/types'

export const useBulkAssignExportRequests = (
  options?: UseMutationOptions<BulkAssignExportRequestsResponse, ApiErrorResponse, BulkAssignExportRequestsParams>
) => {
  const toast = useToast()
  const queryClient = useQueryClient()

  return useMutation<BulkAssignExportRequestsResponse, ApiErrorResponse, BulkAssignExportRequestsParams>({
    mutationFn: params => bulkAssignExportRequests(params),
    onError: () => {
      toast({ message: 'Failed to assign export requests', type: 'error' })
    },
    ...options,
    onSuccess: (data, variables, onMutateResult, context) => {
      invalidateRequestActivityQueries(queryClient)
      options?.onSuccess?.(data, variables, onMutateResult, context)
    }
  })
}
